var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("TranscriptHeaderMeta", {
        staticClass: "mb-4",
        attrs: {
          "start-time-formatted": _vm.startTimeFormatted,
          duration: _vm.duration,
          status: _vm.transcriptStatus,
          "ai-status": _vm.aiStatus,
          profissional: _vm.profissionalNome
        }
      }),
      _c("TranscriptLinkFields", {
        staticClass: "mb-4",
        attrs: {
          "client-name": _vm.clientNome,
          "project-name": _vm.projectNome
        },
        on: {
          "edit-client": _vm.openClientModal,
          "edit-project": _vm.openProjectModal
        }
      }),
      _c("TranscriptSentimentCard", {
        staticClass: "mb-4",
        attrs: {
          sentimento: _vm.sentimento,
          justificativa: _vm.sentimentoJustificativa,
          alinhamento: _vm.sentimentoAlinhamento,
          score: _vm.projectScore
        }
      }),
      _vm.hasAiError
        ? _c(
            "div",
            { staticClass: "mb-4" },
            [
              _c(
                "GeneralAlert",
                {
                  attrs: { status: "error_v3", center: "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "button",
                        fn: function() {
                          return [
                            _c(
                              "BaseButton",
                              {
                                staticClass: "mr-3",
                                attrs: {
                                  sm: "",
                                  fitContent: "",
                                  primary: "",
                                  loading: _vm.regenerating
                                },
                                on: { click: _vm.handleRegenerate }
                              },
                              [_vm._v(" Tentar novamente ")]
                            )
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    1613252241
                  )
                },
                [
                  _c(
                    "p",
                    {
                      staticClass:
                        "az-text-primary az-size-14 font-semibold mb-1"
                    },
                    [_vm._v(" Erro ao gerar resumo ")]
                  ),
                  _c("span", { staticClass: "az-text-small" }, [
                    _vm._v(_vm._s(_vm.aiErrorMessage))
                  ])
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _c("v-divider")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }